"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgHome(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0L4 5.5V7h1v9h5v-6h4v6h5V7h1V5.5z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Home')(SvgHome);
//# sourceMappingURL=Home.js.map